module.exports = __webpack_public_path__ + "media/images/pikkachan_hatena-0ffce28d5145174002f24f4ae51a9faf.png";